import { gql } from 'graphql-request';

export const regNoSearchQuery = gql`
    query regNoSearch($searchTerm: String!) {
        regNoSearch(searchTerm: $searchTerm) {
            name
            id
            regNumber
            approvalCeasedDate
            usageForbiddenDate
            matches {
                indices
                value
                key
            }
        }
    }
`;

export const multiSearchQuery = gql`
    query multiSearch($productSlugs: [String!]!) {
        multiSearch(productSlugs: $productSlugs) {
            name
            id
            regNumber
            productName
            productSlug
            productRegistrationNumber
            approvalCeasedDate
            usageForbiddenDate
        }
    }
`;
